function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.8415 44.1625C18.3769 55.4821 32.8511 59.3605 44.1707 52.8251C55.4903 46.2898 59.3687 31.8155 52.8333 20.4959C46.298 9.17633 31.8237 5.29796 20.5041 11.8333C9.18452 18.3687 5.30614 32.843 11.8415 44.1625ZM16.6083 41.4122C21.6238 50.0993 32.732 53.0758 41.4191 48.0603C50.1063 43.0448 53.0827 31.9366 48.0672 23.2495C43.0517 14.5624 31.9435 11.5859 23.2564 16.6014C14.5693 21.6169 11.5928 32.7251 16.6083 41.4122Z",
  fill: "url(#paint0_angular)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_angular",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(49.3994 31.7789) rotate(164.932) scale(29.6392)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BECE31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BECE31",
  stopOpacity: 0
})));
var SvgLoader = function SvgLoader(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LOADER.2a69a069.svg";
export { ForwardRef as ReactComponent };